// extracted by mini-css-extract-plugin
export var borderRadius = "_4l-4";
export var large = "_4l-3";
export var logoContainer = "_4l-0";
export var nameLogo = "_4l-2";
export var small = "_4l-1";